enum StorageKeys {
  SELECTED_POSITIONS = "selected_positions",
  MATCHPLAY_SELECTED_POSITIONS = "matchplay_selected_positions",
  MATCHPLAY_SETTINGS = "matchplay_settings",
  SELECTED_PHASES = "selected_phases",
  DECISION_INSIGHTS_RATINGS = "decision_insights_ratings",
}

export default StorageKeys;
